<style xmlns="http://www.w3.org/1999/html">
    .header-home-nav, .home-footer {
        background: url(~@/assets/hometeacher/images/green-green-fon.png) !important;
        padding-bottom: 10px;
    }

</style>

<template>
    <div>
        <div class="container-fluid blue-letters-girl">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <div class="breadcrumbs">
                            <a href="/">Главная</a> / Информационная перегрузка: как помочь детям с ней справиться
                        </div>

                        <h1 class="">Бесплатный вебинар</h1>

                        <h3>&laquo;Информационная перегрузка:<br>как помочь детям с&nbsp;ней справиться&raquo;</h3>


                        <div class="mobile-vers" style="margin-left: -15px; margin-right: -15px;"><img
                                src="~@/assets/hometeacher/images/skorochtenie.jpg" alt="Полугодовой курс скорочтения"
                                class="mobile girl-notik"></div>

                        <div class="webinar-date">11 ноября (четверг)</div>
                        <div class="webinar-time">15:30 МСК</div>

                        <div class="knpk"><a href="javascript:void(0);" @click="tryFree">УЧАСТВОВАТЬ!</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid vkurs">
            <div class="container">
                <div class="row mobile-vers">
                    <div class="col-12">
                        <input type="checkbox" id="check" checked>
                        <label for="check"><h2 class="iba">На вебинаре Вы узнаете</h2>
                            <img src="~@/assets/hometeacher/images/galocka.png" class="galocka"></label>
                        <div class="block">
                            <img src="~@/assets/hometeacher/images/girl-wow-skor.jpg"
                                 alt="Полугодовой курс скорочтения">
                            <div>

                                <p style="font-size: 3px;">&nbsp;</p>

                                <div class="chek"></div>
                                <p>Как не отбить у ребенка желание учиться?</p>
                                <div class="chek"></div>
                                <p>Как помочь ребенку быстрее справляться с домашним заданием?</p>
                                <div class="chek"></div>
                                <p>Что такое эффективное чтение и как ему научиться?</p>
                                <div class="chek"></div>
                                <p>Какие упражнения использовать для развития концентрации на тексте?</p>

                                <p style="font-size: 3px;">&nbsp;</p>

                                <div class="red-chek"></div>
                                <p class="onlain-kons" style="background-image: none;"><span class="strong-red" style="font-size: 26px;">В качестве бонуса Вы получите 100 скороговорок по артикуляции и промокод на скидку в размере 20 процентов на курс по скорочтению.</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row desktop-vers">
                    <div class="col-12">
                        <h2 class="iba desktop-vers">На вебинаре Вы узнаете</h2>

                        <img src="~@/assets/hometeacher/images/girl-wow-skor.jpg" alt="Полугодовой курс скорочтения">


                        <div class="chek"></div>
                        <p>Как не отбить у ребенка желание учиться?</p>
                        <div class="chek"></div>
                        <p>Как помочь ребенку быстрее справляться с домашним заданием?</p>
                        <div class="chek"></div>
                        <p>Что такое эффективное чтение и как ему научиться?</p>
                        <div class="chek"></div>
                        <p>Какие упражнения использовать для развития концентрации на тексте?</p>
                        <p style="font-size: 3px;">&nbsp;</p>
                        <p style="font-size: 3px;">&nbsp;</p>
                        <div class="red-chek"></div>
                        <p class="onlain-kons" style="background-image: none;"><span class="strong-red" style="font-size: 26px;">В качестве бонуса Вы получите 100 скороговорок по артикуляции и промокод на скидку в размере 20 процентов на курс по скорочтению.</span>
                        </p>

                    </div>

                </div>
            </div>
        </div>
        <div class="container-fluid beigetop"></div>
        <div class="container-fluid beigefon">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-7 komu-polezen">
                        <h2>Кому будет полезен вебинар:</h2>
                        <div class="red-chek"></div>
                        <p>Родителям, которые хотят повысить результативность обучения своих детей</p>
                        <div class="red-chek"></div>
                        <p>Родителям, дети которых не справляются со школьной программой</p>
                        <div class="red-chek"></div>
                        <p>Родителям, у которых нет времени водить ребенка на дополнительные занятия</p>
                        <div class="red-chek"></div>
                        <p>Всем, кто интересуется повышением своей продуктивности и скорости чтения</p>

                    </div>

                    <div class="col-12 col-sm-5">
                        <img src="~@/assets/hometeacher/images/strlka.png">
                        <div class="knpk-yellow"><a href="javascript:void(0);" @click="tryFree">Участвовать в
                            вебинаре!</a></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid beigedown"></div>

        <div class="container-fluid blue-letters-back">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2 class="desktop-vers">Спикер вебинара: Татьяна Сидорова</h2>
                        <h2 class="mobile-vers">Спикер вебинара:<br>
                            Татьяна Сидорова
                        </h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="tatiana-webinar-descr">
                            <img src="~@/assets/hometeacher/images/tatiana-webinar.jpg" alt="Сидорова Татьяна"
                                 class="tatiana-webina-foto mt-lg--3">

                            Кандидат педагогических наук, педагог, методист международной сети языковых центров
                            Полиглотики,
                            автор курса "Скорочтение" ТМ Полиглотики.

                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <video src="https://poliglotiki.com/video/webinar-about.mp4" style="max-width:99%;" class="mt-lg-5"
                               controls="controls"></video>
                    </div>
                </div>
            </div>
        </div>


        <EntryWebinar/>

        <div class="container-fluid blue-letters-back" style="box-shadow: inset 0 3px 5px #00000038">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2 class="mt-lg-0 mt-3">Выбирайте абонемент уже сейчас:</h2>
                    </div>
                </div>

                <StudyProductSubscriptionList
                        :subscriptions="subscriptions"
                        @order="orderSubscription"
                />
              <div class="row">
                <div class="col-12">
                  <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                          src="https://www.poliglotiki.ru/embed/lCKl1aSe1CA" frameborder="0"
                          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                          allowfullscreen></iframe>

                </div>
              </div>
            </div>
        </div>


    </div>
</template>

<script>
    import moment from 'moment';
    import EntryWebinar from "./EntryWebinar";
    import studyProductApi from "../data/StudyProductApi";
    import StudyProductSubscriptionList from "./Study/landing/StudyProductSubscriptionList";

    export default {
        components: {
            EntryWebinar, StudyProductSubscriptionList
        },
        name: "InformacionnayaPeregruzka",

        data: function () {
            return {
                title: null,
                slug: 'godovoj-kurs-skorochteniya',
                subscriptions: [],
                freeSubscription: null,
                promoSuscription: null,
                courses: [],

            }
        },

        mounted() {
            moment.locale(this.$i18n.locale)
            this.loading = true

            studyProductApi.fetchStudyProductSlug(this.slug)
                .then(response => {
                    this.subscriptions = response.subscriptions.filter(s => {
                        if (s.price <= 0) {
                            this.freeSubscription = s
                            return false
                        }
                        return s.price > 0
                    })
                    this.courses = response.courses

                })
                .catch(error => {
                    let data = error.response.data
                    this.error = this.pretty(data)
                    this.loading = false
                })

        },

        methods: {
            orderSubscription(subscription) {
                this.$router.push('/subscription/order/' + subscription.idsubscription)
            },
            tryFree() {
                document.getElementById('entry').scrollIntoView();
            },
        },

        metaInfo() {
            return {
                title: 'Бесплатный вебинар «Информационная перегрузка: как помочь детям с ней справиться»',
                meta: [
                    {
                        vmid: 'description',
                        name: 'description',
                        content: 'Бесплатный вебинар «Информационная перегрузка: как помочь детям с ней справиться»'
                    }
                ]
            }
        },
    }
</script>

<style scoped>
    .tatiana-webina-foto {
        border-radius: 50%;
        box-shadow: 1px 2px 7px 1px rgba(40, 40, 40, .5);
        margin-bottom: 15px;
        width: 190px;
        height: 190px;
        object-fit: cover;
        max-width: 100%;
        float: left;
        margin-right: 80px;
    }

    .tatiana-webinar-descr {
        font-size: 30px;
        margin-top: 30px;
        margin-bottom: 30px;
    }

    .beigefon .komu-polezen p {
        margin-top: 0;
    }

    .webinar-date, .webinar-time {
        font-family: "Manrope Bold";
    }

    .webinar-date {
        margin-top: 30px;
        font-size: 72px;
    }

    .webinar-time {
        font-size: 60px;
        margin-bottom: 60px;
    }

    .blue-letters-girl {
        background: url(~@/assets/hometeacher/images/blue-letters-skorochteniye.jpg) no-repeat center;
        text-align: left;
        box-shadow: inset 0 3px 5px #00000038;
        padding-top: 10px;
        min-height: 878px;
    }

    .breadcrumbs {
        font-size: 14px;
        background: #fff;
        max-width: 360px;
        padding-left: 7px;
        border-radius: 10px;
        margin-left: -7px;
    }

    .blue-letters-girl h1 {
        font-size: 50px;
        font-family: Manrope Black;
        margin-top: 15px;
        margin-bottom: 0px;
        color: #000;
    }

    .skorochteniya {
        background: url(~@/assets/hometeacher/images/skorochteniya.png) no-repeat right center;
        padding-left: 8px;
        padding-right: 9px;
        padding-top: 0px;
        padding-bottom: 9px;
    }
    .vidos {width:100%; height: 623px;}
    .blue-letters-girl h3 {
        font-size: 30px;
        font-family: Manrope Bold Alt;
        margin-bottom: 20px;
        color: #000;
    }

    .blue-letters-girl p {
        font-size: 20px;
        max-width: 750px;
    }

    .blue-fon-text {
        background: #00b4f1;
        color: #fff;
        border-radius: 15px;
        padding: 2px 10px;
    }

    .knpk {
        border-radius: 35px;
        max-width: 230px;
        font-family: Manrope Bold Alt;
        background: -webkit-gradient(linear, left bottom, left top, from(#39ab22), to(#49d92c));
        font-size: 22px;
        color: #fff;
        padding: 15px 30px;
        box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
        text-decoration: none;
        text-shadow: 1px 1px 1px rgb(0 0 0 / 30%);
        margin-top: 30px;
    }

    .knpk:hover {
        background: #49d92c;
    }

    .knpk a {
        color: #fff;
    }

    .vkurs {
        padding-top: 60px;
    }

    .vkurs h2 {
        font-size: 40px;
        font-family: Manrope Bold Alt;
        color: #262239;
        margin-bottom: 30px;
    }

    .vkurs h3 {
        font-size: 25px;
        font-family: "Manrope Bold";
        color: #231c37;
        margin-top: 30px;
    }

    .vkurs img {
        float: right;
        margin-right: -35px;
    }

    .vkurs p, .komu-polezen p {
        font-size: 20px;
        margin-left: 35px;
        line-height: 1.4;
        color: #000;
        max-width: 599px !important;
        border-top-right-radius: 30px;
        border-bottom-right-radius: 85px;
    }

    .leftp {
        margin-left: 0px !important;
    }

    .red-chek {
        background: url(~@/assets/hometeacher/images/red-chek.png) no-repeat 0 0;
        font-size: 20px;
        float: left;
        width: 25px;
        height: 20px;
        margin-top: 8px;
    }

    .bezlimit-group {
        background-image: url(~@/assets/hometeacher/images/bezlimit-group.png);
        line-height: 1.6 !important;
        padding-left: 8px;
        padding-bottom: 3px;
        padding-right: 8px;
        max-width: 589px !important;
    }

    .onlain-kons {
        background-image: url(~@/assets/hometeacher/images/onlain-kons.png);
        line-height: 1.4 !important;
        padding-left: 8px;
        padding-bottom: 0px;
        padding-right: 8px;
        max-width: 654px !important;
        padding-top: 2px;
    }

    .chek {
        background: url(~@/assets/hometeacher/images/chek.png) no-repeat 0 0;
        font-size: 20px;
        float: left;
        width: 25px;
        height: 20px;
        margin-top: 8px;
    }

    .beigetop {
        background: url(~@/assets/hometeacher/images/beigetop.png) repeat center;
        width: 100%;
        height: 91px;
        margin-top: 50px;
    }

    .beigedown {
        background: url(~@/assets/hometeacher/images/beigedown.png) repeat center;
        width: 100%;
        height: 103px;
        margin-top: -1px;
    }

    .beigedown-white {
        background: url(~@/assets/hometeacher/images/beigedown-white.png) repeat center;
        width: 100%;
        height: 105px;
    }

    .beigefon {
        background: #eac675;
        min-height: 350px;
        overflow: hidden;
        padding-bottom: 0px;
        padding-top: 30px;
    }

    .beigefon img {
        float: right;
        margin-right: -415px;
        margin-top: 162px;
        height: 33px;
        max-width: 100%;
    }

    .beigefon h2 {
        font-family: Manrope Bold Alt;
        font-size: 40px;
        color: #fff;
        margin-top: 50px;
        line-height: 1.3;
    }

    .beigefon p {
        color: #fff;
        font-size: 18px;
        line-height: 1.4;
        margin-top: 20px;
    }

    .veselo {
        background-image: url(~@/assets/hometeacher/images/effekt-skor.png);
        padding-left: 8px;
        padding-top: 2px;
        padding-bottom: 8px;
        color: #000;
        padding-right: 8px;
    }

    .knpk-yellow {
        border-radius: 35px;
        text-align: center;
        max-width: 390px;
        font-family: Manrope Bold Alt;
        background: -webkit-gradient(linear, left bottom, left top, from(#ffce00), to(#fbfe00));
        font-size: 24px;
        padding: 15px 30px;
        -webkit-box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
        box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
        text-decoration: none;
        margin-top: 145px;
    }

    .knpk-yellow:hover {
        background: #fbfe00;
    }

    .knpk-yellow a {
        color: #000;
    }

    .blue-letters-back {
        background-image: url(~@/assets/hometeacher/images/blue-letters-back.png);
        margin-top: 0;
        padding-bottom: 100px;
        text-align: left;
        padding-top: 70px;
    }

    .blue-letters-back h2 {
        font-size: 40px;
        font-family: "Manrope Black";
        color: #262239;
    }

    .viborabonement {
        background-image: url(~@/assets/hometeacher/images/viborabonement.png);
        padding-left: 8px;
        padding-top: 1px;
        padding-bottom: 8px;
        padding-right: 8px;
    }

    .abonement {
        max-width: 254px;
        min-height: 233px;
        border: 1px solid #d9e0e4;
        background: #fff;
        text-align: center;
        margin-top: 50px;
        border-radius: 10px;
        box-shadow: 2px 2px 9px rgb(0 0 0 / 20%);
    }

    .month-1, .month-3, .month-6, .month-12 {
        font-size: 22px;
        text-align: center;
        font-family: "Manrope Bold Alt";
        margin-bottom: 15px;
    }

    .month-1 {
        background: url(~@/assets/hometeacher/images/month-1.png) no-repeat center;
        margin-top: 30px;
        color: #231c37;
    }

    .month-3 {
        background: url(~@/assets/hometeacher/images/month-3.png) no-repeat center;
        margin-top: 30px;
        color: #231c37;
    }

    .month-6 {
        background: url(~@/assets/hometeacher/images/month-6.png) no-repeat center;
        margin-top: 30px;
        color: #231c37;
    }

    .month-12 {
        background: url(~@/assets/hometeacher/images/month-12.png) no-repeat center;
        margin-top: 4px;
        color: #fff;
    }

    .price {
        font-family: "Manrope Bold";
        font-size: 30px;
        color: #72717d;
    }

    .rubls {
        font-size: 18px;
    }

    .econom {
        font-size: 15px;
        color: #231c37;
        margin-bottom: 17px;
        margin-top: -6px;
        text-shadow: 0px 0px 0px rgb(0 0 0);
        font-weight: bold;
    }

    .all-course {
        color: #ed1c24;
        font-family: "Manrope Black";
        font-size: 18px;
    }

    .abonement a {
        border-radius: 35px;
        max-width: 230px;
        font-family: Manrope Bold Alt;
        background: -webkit-gradient(linear, left bottom, left top, from(#39ab22), to(#49d92c));
        font-size: 20px;
        color: #fff;
        padding: 14px 35px;
        box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
        text-decoration: none;
    }

    .abonement a:hover {
        background: #49d92c;
    }

    .getpresent {
        box-shadow: inset 0 3px 5px #00000038;
        padding-top: 100px;
    }

    .getpresent h3 {
        font-size: 30px;
        font-family: Manrope Bold Alt;
        color: #262239;
        margin-bottom: 40px;
    }

    .toget {
        background-image: url(~@/assets/hometeacher/images/toget.png);
        padding-left: 8px;
        padding-top: 3px;
        padding-bottom: 10px;
        padding-right: 8px;
    }

    .bigwavetop {
        background: url(~@/assets/hometeacher/images/bigwavetop.png) no-repeat center;
        width: 100%;
        height: 190px;
    }

    .present {
        width: 220px;
        height: 469px;
        border: 1px solid #d7e1e5;
        margin-right: -1px;
        padding: 20px;
        overflow: hidden;
        margin: 0 auto 10px auto;
    }

    .present img {
        border-radius: 10px;
    }

    .podarok {
        margin-left: 95px;
        margin-top: -285px;
    }

    .dific {
        margin-top: -30px;
    }

    .present h4 {
        font-family: "Manrope Bold";
        font-size: 18px;
        color: #262239;
        line-height: 1;
        margin-top: -9px;
        margin-bottom: 12px;
    }

    .present h4 a {
        color: #262239;
    }

    .present p {
        font-family: "Manrope Book";
        color: #4f4d5c;
        font-size: 14px;
        line-height: 1;
        margin-bottom: 10px;
    }

    .cennik {
        font-family: "Manrope Bold";
        font-size: 20px;
        color: #262239;
        position: absolute;
        bottom: 20px;
    }

    .cennik span {
        color: #4f4d5c;
        font-size: 16px;
        font-family: "Manrope Light";
        font-weight: bold;
    }

    .obuchenie {
        padding-top: 100px;
        padding-bottom: 60px;
        box-shadow: inset 0 3px 5px #00000038;
    }

    .obuchenie h2, .sm-video h2 {
        font-size: 40px;
        font-family: Manrope Bold Alt;
        color: #262239;
        margin-bottom: 60px;
    }

    .obuchenie p {
        font-size: 18px;
        width: 270px;
        line-height: 1.4;
    }

    .strela {
        background-image: url(~@/assets/hometeacher/images/strela.png);
        width: 176px;
        height: 19px;
        margin-top: 20px;
        left: 100px;
        position: absolute;
    }

    .bluekrug {
        width: 60px;
        height: 60px;
        border: 3px solid #00b4f1;
        border-radius: 50%;
        text-align: center;
        color: #4f4d5c;
        background: #fff;
        padding-top: 10px;
        font-size: 24px;
        font-family: "Manrope Bold";
        margin-bottom: 20px;
        position: relative;
        z-index: 10;
    }

    .strelka-krivaya {
        margin-left: 35px;
        margin-top: -40px;
        padding-bottom: 5px;
        max-width: 100%;
    }

    .hello {
        position: absolute;
        top: -150px;
        left: -20px
    }

    .sertifikat {
        background-image: url(~@/assets/hometeacher/images/sertifikat.png);
        padding-left: 8px;
        padding-top: 3px;
        padding-bottom: 8px;
        padding-right: 8px;
    }

    .sm-video {
        padding-top: 80px;
    }

    .sm-video p {
        margin-top: -100px;
        font-size: 18px;
        font-family: 'Manrope Book';
        color: #000;
        text-align: center;
    }

    /*.vidos {
        width: 100%;
        height: 192px;
        border-radius: 15px;
        margin-right: 0 !important;
        margin-bottom: 100px !important;
    }
*/
    .otzivh2 {
        font-size: 36px !important;
        font-family: "Manrope Black" !important;
        color: #231c37 !important;
        margin-bottom: 60px !important;
    }

    .indotz {
        float: left;
        margin-right: 20px;
    }

    .nameotzyv {
        font-size: 21px;
        font-family: Manrope Bold;
        display: block;
        color: #000;
    }

    .text-otziv {
        font-size: 17px;
        color: #000;
        line-height: 1.4;
        margin-top: 10px;
    }

    .centers-text {
        max-width: 500px;
    }

    .allotzv {
        color: #0493c3;
        font-size: 20px;
        font-family: "Manrope Bold";
        padding: 15px 30px;
        border: 2px solid #0493c3;
        border-radius: 30px;
    }

    .allotzv:hover {
        background: #0493c3;
        color: #fff;
    }

    .viborabon-last {
        background-image: url(~@/assets/hometeacher/images/viborabon-last.png);
        padding-left: 8px;
        padding-top: 1px;
        padding-bottom: 8px;
        padding-right: 8px;
    }

    .last-stav {
        padding-top: 70px;
        padding-bottom: 120px;
    }

    .last-stav h2 {
        font-size: 40px;
        font-family: "Manrope Bold Alt";
        color: #262239;
    }

    .girl-notik {
        margin-left: -25px;
        margin-bottom: 20px;
        max-width: 110%;
    }

    .liniya {
        background-image: url(~@/assets/hometeacher/images/liniya.png);
        width: 100%;
        height: 36px;
        margin-top: 30px;
    }

    .greenback {
        background: #5ab947;
        margin-bottom: 0px;
        padding-bottom: 100px;
        box-shadow: inset 0 3px 5px #00000038;
    }

    .h2desctop {
        font-size: 40px;
        font-family: 'Manrope Bold Alt';
        color: #fff;
        margin-top: 60px;
    }

    .fotokind {
        text-align: center;
        padding-top: 80px;
    }

    .fotokind img {
        max-width: 100%;
    }

    .nameresult {
        font-family: Manrope Bold;
        color: #fff;
        font-size: 24px;
    }

    .textresult {
        padding-top: 80px;
        margin-left: -40px;
    }

    .textresult p {
        color: #fff;
        font-size: 18px;
        margin-top: 20px;
        line-height: 1.5;
        margin-bottom: 25px;
        max-width: 570px
    }

    .center-delimeter-green {
        height: 1px;
        background-color: #87d575;
        margin-top: 35px;
        margin-bottom: 20px;
    }

    .shapka {
        font-size: 16px;
        color: #caffbb;
        font-family: 'Manrope Light';
        height: 24px;
        margin-bottom: 5px;
    }

    .stalo {
        font-size: 22px;
        color: #fff;
        font-family: Manrope Bold;
        margin-bottom: 5px;
    }

    .bilo {
        font-size: 18px;
        color: #caffbb;
        font-family: Manrope Bold;
    }

    @media (max-width: 1199px) {
        .obuchenie {
            overflow: hidden;
        }

        .hello {
            top: -110px;
            left: -115px;
        }

        .cennik {
            position: inherit;
        }
    }

    @media (max-width: 991px) {
        .tatiana-webina-foto {
            float: none;
            display: block;
            margin-left: auto;
            margin-right: auto;
            margin-bottom: 30px;
        }

        .abonement a {
            padding: 10px;
        }

        .centers-text {
            max-width: 100%;
            text-align: center;
        }

        .vidos {
            height: 370px;
        }

        .indotz {
            float: none;
            margin-bottom: 20px;
        }

        .blue-letters-girl h1 {
            background: none;
        }

        .bezlimit-group, .onlain-kons {
            background: none;
        }

        .obuchenie p {
            width: 100%;
        }

        .strela {
            display: none;
        }

        .hello {
            top: -160px;
        }
    }

    input[type="checkbox"] {
        display: none;
    }

    label {
        cursor: pointer;
        color: #fff;
        text-decoration: underline;
        -moz-user-select: -moz-none;
        -webkit-user-select: none;
        user-select: none;
    }

    .block {
        width: 100%;
        display: none;
    }

    input:checked ~ .block {
        display: block;
    }

    .galocka {
        margin-right: 0px !important;
        margin-top: -110px;
        float: right !important;
    }

    @media (max-width: 575px) {
        .blue-letters-girl {
            padding-left: 15px !important;
            padding-right: 15px !important;
            padding-bottom: 60px;
            background: url(~@/assets/hometeacher/images/blue-letters-back.png) repeat;
        }
      .vidos {height:300px;}
        .blue-letters-girl h1 {
            font-size: 40px;
            line-height: 1.1;
        }

        .blue-letters-girl h3 {
            font-size: 22px;
            margin-top: 10px;
        }

        .skorochteniya {
            background-image: url(~@/assets/hometeacher/images/skorochteniya-mob.png);
            font-size: 40px;
            padding-left: 12px;
            padding-top: 9px;
            padding-bottom: 16px;
            padding-right: 7px;
        }

        .vkurs {
            padding-left: 15px !important;
            padding-right: 15px !important;
            box-shadow: inset 0 3px 5px rgb(0 0 0 / 22%);
        }

        .vkurs h2 {
            font-size: 33px;
        }

        .vkurs img {
            float: none;
            max-width: 80%;
            margin-right: 0px !important;
        }

        .beigefon, .blue-letters-back {
            padding-left: 15px !important;
            padding-right: 15px !important;
            padding-top: 0px;
            padding-bottom: 10px;
        }

        .beigefon h2 {
            font-size: 25px;
            line-height: 1.5;
        }

        .beigefon img {
            display: none;
        }

        .beigetop {
            margin-top: 0px;
            margin-bottom: -1px;
        }

        .veselo {
            background-image: url(~@/assets/hometeacher/images/effekt-skor-mob.png);
            padding-left: 8px;
            padding-top: 5px;
            padding-bottom: 10px;
            font-size: 22px;
            color: #000;
            padding-right: 8px;
        }

        .knpk-yellow {
            margin-top: 40px;
            font-size: 20px;
            padding: 15px;
        }

        .blue-letters-back h2, .last-stav h2 {
            font-size: 33px;
            text-align: center;
        }

        .viborabonement {
            background-image: url(~@/assets/hometeacher/images/viborabonement-mob.png);
            width: 240px;
            line-height: 1.2;
            margin: 0 auto;
            padding-top: 1px;
            padding-bottom: 2px;
            margin-bottom: 30px;
            margin-top: -10px;
        }

        .abonement {
            margin: 0 auto;
            margin-bottom: 30px;
        }

        .abonement a {
            padding: 15px 35px;
        }

        .getpresent {
            padding-left: 15px !important;
            padding-right: 15px !important;
            padding-top: 60px;
            text-align: center;
        }

        .toget {
            background-image: url(~@/assets/hometeacher/images/toget-mob.png);
            text-align: left;
            width: 285px;
            line-height: 1.2;
            margin: 0 auto;
            padding-top: 1px;
            padding-bottom: 10px;
            margin-bottom: 30px;
            margin-top: -10px;
        }

        .present {
            float: none;
            margin: auto;
            width: 270px;
            height: 450px;
            text-align: left;
            box-shadow: 2px 2px 9px rgb(0 0 0 / 20%);
            border-radius: 10px;
        }

        .podarok {
            margin-left: 145px;
        }

        .cennik {
            position: absolute;
        }

        .obuchenie {
            padding-left: 15px !important;
            padding-right: 15px !important;
            padding-top: 50px;
            padding-bottom: 0px;
            margin-bottom: -20px
        }

        .obuchenie h2 {
            font-size: 33px;
        }

        .bluekrug {
            float: left;
            margin-right: 10px;
            margin-bottom: 45px;
        }

        .sm-video, .last-stav {
            padding-left: 15px !important;
            padding-right: 15px !important;
            padding-top: 0px;
        }

        .sm-video h2 {
            font-size: 30px;
        }

        .sertifikat {
            background: none;
            padding-left: 0px;
        }

    /*    .vidos {
            height: 280px;
        }*/

        .last-stav {
            background: url(~@/assets/hometeacher/images/blue-letters-back.png) repeat;
            padding-bottom: 0px;
        }

        .h2desctop {
            color: #fff;
            margin-top: 0px;
            line-height: 1.1;
            margin-bottom: 40px;
            font-size: 30px;
        }

        .greenback {
            padding-top: 40px; /*margin-top: 25px;*/
            padding-left: 15px !important;
            padding-right: 15px !important;
            padding-bottom: 50px;
        }

        .greenback p {
            font-size: 18px;
            color: #fff;
            line-height: 1.5;
            margin-top: 5px;
        }

        .fotokind {
            padding: 0px;
        }

        .kray {
            margin-left: -30px;
            margin-right: -30px;
        }

        .nameresult {
            margin-top: 30px;
            margin-bottom: 30px;
        }

        .shapka {
            color: #ffdb00;
            text-shadow: 0px 0px 0px #ffdb00;
        }

        .stalo {
            font-size: 22px;
        }

        .bilo {
            font-size: 18px;
        }
    }
    @media (max-width: 540px) {
      .vidos {height:295px;}
    }
    @media (max-width: 480px) {
      .vidos {height:245px;}
    }
    @media (max-width: 420px) {
      .vidos {height:210px;}
    }
    @media (max-width: 380px) {
      .vidos {height:195px;}
    }
    @media (max-width: 320px) {
      .vidos {height:155px;}
    }
    @media (max-width: 404px) {
        /* veselo { background-image: url(~@/assets/hometeacher/images/effekt-skor-mob.png);
           padding-left: 8px;  padding-top: 5px; padding-bottom: 10px; font-size: 22px;
           color: #000;  padding-right: 8px;}*/
    }

    @media (max-width: 370px) {
        .veselo {
            font-size: 19px;
        }
    }
</style>
